import cx from 'classnames';
import { motion } from 'framer-motion';
import React from 'react';

import * as styles from './PageSection.module.css';

const PageSection = ({
	children,
	id,
	className = '',
	padding = 'md',
	meteoric,
	background = 'white',
	overflow = 'visible',
}: {
	children: React.ReactNode;
	id?: string;
	className?: string;
	padding?: 'sm' | 'md' | 'lg';
	meteoric?: boolean;
	background?: 'grey' | 'blue' | 'white';
	overflow?: 'hidden' | 'visible' | 'breach';
}): JSX.Element => {
	const componentClassNames = cx(
		styles.section,
		styles[`${background}Background`],
		{
			[className]: !!className,
			[styles[`${padding}Padding`]]: padding,
			[styles.meteoric]: meteoric,
			[styles.hideOverflow]: overflow === 'hidden',
			[styles.breachOverflow]: overflow === 'breach',
		}
	);

	return (
		<section id={id} className={componentClassNames}>
			<div className={cx(styles.layout, 'container')}>{children}</div>
		</section>
	);
};

export default PageSection;
